import { PortfolioEnterpriseGroupResult, useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { MewsTeam } from '@mews/enums';

export const useDeletePropertyGroupsMutation = () => {
    const localizeText = useLocalizeText();

    return useRepositoryMutation('portfolioEnterpriseGroups', 'delete', {
        transformParams: (enterpriseGroupResults: PortfolioEnterpriseGroupResult[]) => ({
            ids: enterpriseGroupResults.map((enterpriseGroup) => enterpriseGroup.id),
        }),
        onSuccess: (_, deletedEnterpriseGroups) => {
            const localizedEnterpriseGroupsTextKey =
                deletedEnterpriseGroups.length > 1
                    ? localizeText({ textKey: TextKey.PropertyGroupsNavigation })
                    : deletedEnterpriseGroups[0].name;

            showSuccessAlert({
                description: lt('DeleteSuccessMessage', { entity: localizedEnterpriseGroupsTextKey }),
            });
        },
        invalidateQueries: {
            portfolioEnterpriseGroups: ['getAll'],
            rateGroups: ['getAll'],
            portfolioCentralRateGroups: ['getOverview', 'getAll'],
        },
        meta: {
            logError: {
                team: MewsTeam.Pricing,
            },
        },
    });
};
